const TIMEOUT_BASE = 100; // ms
const MAX_INDEX = 10;
const TIMEOUT_MAX = TIMEOUT_BASE * MAX_INDEX; // ms;

const getTransitionTimeout = (index: number) =>
  index < MAX_INDEX ? TIMEOUT_BASE * index : TIMEOUT_MAX;

export default getTransitionTimeout;
